import { FlightRequest } from 'acscp/components/flightRequest/flightRequest';
import React from 'react';
import { PresentationComponentBase } from 'acscp/components/presentationComponentBase';
import { QuoteAccepted } from 'acscp/components/quotes/quoteAccepted';
import { AppState, Booking, Quote } from 'acscp/store';
import { Dispatch } from 'redux';
import { QuotesRequest } from 'acscp/api/requests';
import { FetchRequest } from 'acscp/actions';
import { getBookingQuotes } from 'acscp/store/helpers/getBookingQuotes';
import { FormattedMessage } from 'react-intl';
import { connectWithRequests } from 'acscp/store/helpers/connectWithRequests';
import { QuoteElement } from '../quotes/quote';

interface AwaitingItineraryOwnProps {
    bookingDetails: Booking;
}

interface AwaitingItineraryStateProps {
    acceptedQuote: Quote;
    otherQuotes: Quote[];
}

interface AwaitingItineraryDispatchProps {
    fetchQuotes: () => void;
}

export class AwaitingItineraryPresentational
        extends PresentationComponentBase<AwaitingItineraryOwnProps,
                                          AwaitingItineraryStateProps,
                                          AwaitingItineraryDispatchProps, {}> {

    componentDidMount(): void {
        this.props.fetchQuotes();
    }

    render(): JSX.Element {
        const {bookingDetails, acceptedQuote} = this.props;
        const title = (
            <FormattedMessage
                id={'components.flightRequest.awaitingItinerary.title'}
                defaultMessage={'CHARTER REQUEST'}
            />
        );
        return (
            <div>
                <FlightRequest
                    bookingDetails={bookingDetails}
                    quoteCount={null}
                    title={title}
                    shouldShowFlightPlan={true}
                />
                {acceptedQuote &&
                <QuoteAccepted
                    quote={acceptedQuote}
                    booking={bookingDetails}
                />}
                {this.props.otherQuotes.map(
                    quote => (
                        <div key={quote.id}>
                            <QuoteElement
                                quote={quote}
                                collapsible={true}
                                jetCardHolder={bookingDetails.jetCardNo !== ''}
                                jetCardType={bookingDetails.jetCardType}
                                disabled={true}
                            />
                        </div>)
                )}
            </div>
        );
    }
}

function mapStateToProps(
    state: AppState,
    ownProps: AwaitingItineraryOwnProps
): AwaitingItineraryStateProps {
    const allQuotes = getBookingQuotes(state.quotes, ownProps.bookingDetails.id);
    const acceptedQuote = allQuotes.filter(q => q.status === 'Accepted')[0];
    return {
       acceptedQuote,
       otherQuotes: allQuotes.filter(q => q.id !== acceptedQuote.id)
    };
}

function mapDispatchToProps(
    dispatch: Dispatch,
    ownProps: AwaitingItineraryOwnProps
): AwaitingItineraryDispatchProps {
    return {
        fetchQuotes: () => dispatch(new FetchRequest(new QuotesRequest(ownProps.bookingDetails.id)))
    };
}

export const AwaitingItinerary = connectWithRequests(mapStateToProps, mapDispatchToProps)
    (AwaitingItineraryPresentational);
